import React, { useEffect, useState } from "react";
import * as Icons from "react-icons/fi"; // Import all icons from react-icons/fi
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { featureApis } from "../../Data/axios";
import Banner from "../../Components/Banner";

const Features = () => {
  const [features, setFeatures] = useState([]);
  // const icons = Object.keys(Icons);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await featureApis.getAll({ page: 1, per_page: 6 }); 
        console.log("API Response:", response.data); 
        setFeatures(response.data); 
      } catch (error) {
        console.error("Error fetching features:", error);
      }
    };

    fetchFeatures();
  }, []);

  return (
    <>
      <Header />
      <div className="bg-topo-bg">
        <div className="container mx-auto font-ubuntu py-16 min-h-[50vh]">
          <hr />
          <div className="text-center mb-12 mt-4">
            <h2 className="text-csyellow text-4xl font-bold mb-4">Our Features</h2>
            <p className="text-gray-700 text-lg font-light text-left">
              Discover the powerful features that make our platform stand out from the competition.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
  {features.map((feature, index) => {
    return (
      <div
        key={feature.id}
        className="p-6 bg-csghost rounded-xl shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl font-ubuntu flex flex-col justify-between"
      >
        <div>
          {/* Title with fixed height */}
          <h3
            className="text-2xl font-bold mb-2 text-gray-800 overflow-hidden"
            style={{ height: "3rem" }} // Fixed height for the title
          >
            {feature.title}
          </h3>
          {/* Image */}
          <div className="w-full h-48 overflow-hidden mb-4">
            <img
              src={`https://rptpl.roadpilot.co.in/public/${feature.image}`}
              alt={feature.title}
              className="w-full h-auto object-cover mb-4"
            />
          </div>
          {/* Description */}
          <div className="h-20 overflow-hidden">
            <p className="text-gray-600 line-clamp-3">{feature.description}</p>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-7 flex justify-between">
          <button
            onClick={() => navigate("/contact-us")}
            className="px-4 py-2 bg-csyellow text-white rounded-lg hover:bg-gray-400 transition-colors duration-300"
          >
            Learn More
          </button>
          {feature.Tutorial && (
            <button
              onClick={() =>
                window.open(feature.Tutorial, "_blank", "noopener,noreferrer")
              }
              className="px-4 py-2 bg-csyellow text-white rounded-lg hover:bg-gray-400 transition-colors duration-300"
            >
              Tutorial
            </button>
          )}
        </div>
      </div>
    );
  })}
</div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Features;